export default __webpack_public_path__ + "static/media/pic44.d563f378.jpg";